import React, { useEffect, useState } from "react";
import { BASE_URL } from "./BaseUrl";
import EditIcon from "@mui/icons-material/Edit";
import { GridToolbarContainer, GridToolbarFilterButton } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import InnerHeader from "./InnerHeader";
import axios from "axios";
import { Button, Switch } from "@mui/material";
import Loader from "./Loader";
import * as XLSX from "xlsx";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { StyledDataGrid } from "./StyledDataGrid";
import _debounce from "lodash.debounce";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { getRoleData } from "../Store/Role/role-action";

const Students = () => {
    const [excelData, setExcelData] = useState([]);
    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarFilterButton />
            </GridToolbarContainer>
        );
    }
    const [loading, setLoading] = useState(true);
    const label = { inputProps: { "aria-label": "Color switch demo" } };
    const [students, setStudents] = useState([]);
    const [page, setPage] = useState(0); // Current page
    const [pageSize, setPageSize] = useState(10); // Number of records per page
    const [lastStudentId, setLastStudentId] = useState(null);
    const [totalstudent, setTotalStudent] = useState("");
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [searchwise, setSearchWise] = useState("");
    const [searchdata, setSearchData] = useState("");
    const [searchtext, setText] = useState("");
    const [data, setData] = useState([]);

    async function getOnlineAdmissions(pageNumber = page, size = pageSize) {
        setLoading(true);
        const postData = {
            page: pageNumber,
            pageSize: size,
        };
        try {
            const response = await axios.post(`${BASE_URL}/getAllStudent`, postData);
            if (response.data) {
                const studentList = Array.isArray(response.data.data) ? response.data.data : [];
                setStudents(studentList);
                setLastStudentId(response.data.lastStudentId ?? null);

                // Check active non-deleted count: if on page 0 and list is smaller than page size,
                // the total count is accurately studentList.length.
                const actualCount =
                    pageNumber === 0 && studentList.length < size
                        ? studentList.length
                        : response.data.totalCount ?? studentList.length;

                setTotalStudent(actualCount);
            }
        } catch (error) {
            console.error("Error fetching students:", error);
            setStudents([]);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getOnlineAdmissions(page, pageSize);
    }, [page, pageSize]);

    const handleswitchchange = (currentValue, Student_Id) => {
        const isCurrentActive = currentValue == 1 || currentValue === true || currentValue === "1";
        const newval = isCurrentActive ? 0 : 1;

        axios
            .post(`${BASE_URL}/data_status`, {
                status: newval,
                Inquiry_Id: Student_Id,
                table_name: "Student_Master",
            })
            .then(() => {
                getOnlineAdmissions(page, pageSize);
            })
            .catch((err) => {
                console.error("Error updating status:", err);
            });
    };

    const roledata = {
        role: Cookies.get("role"),
        pageid: 25,
    };

    const dispatch = useDispatch();
    const roleaccess = useSelector((state) => state.roleAssign?.roleAssign[0]?.accessid);

    useEffect(() => {
        dispatch(getRoleData(roledata));
    }, []);

    const columns = [
        {
            field: "index",
            headerName: "Sr. No.",
            type: "number",
            align: "center",
            headerAlign: "center",
            flex: 0.6,
            filterable: false,
        },
        {
            field: "Student_Id",
            headerName: "Student Id",
            type: "text",
            align: "center",
            headerAlign: "center",
            flex: 0.8,
            filterable: false,
        },
        { field: "Batch_code", headerName: "Batch Code", flex: 1 },
        { field: "Student_Name", headerName: "Student Name", flex: 2 },
        { field: "Present_Address", headerName: "Address", flex: 2 },
        { field: "Email", headerName: "Email", flex: 2 },
        { field: "Present_Mobile", headerName: "mobile", flex: 1.5 },
        {
            field: "Status",
            headerName: "Status",
            flex: 1.2,
            renderCell: (params) => <span>{params.row?.Status || "Active"}</span>,
        },
        ...(roleaccess > 2
            ? [
                  {
                      field: "actions",
                      type: "actions",
                      headerName: "Action",
                      flex: 1.2,
                      renderCell: (params) => {
                          const isActive = params.row.IsActive ?? params.row.isActive;
                          const isChecked = isActive == 1 || isActive === true || isActive === "1";
                          return (
                              <div className="d-flex align-items-center">
                                  {roleaccess > 3 && (
                                      <Link to={`/admissionform/personalinfo/${params.row.Student_Id}`}>
                                          <EditIcon style={{ cursor: "pointer", marginRight: 8, color: "#1976d2" }} />
                                      </Link>
                                  )}
                                  {roleaccess > 2 && (
                                      <Switch
                                          {...label}
                                          onChange={() => handleswitchchange(isActive, params.row.Student_Id)}
                                          checked={isChecked}
                                          color="secondary"
                                      />
                                  )}
                              </div>
                          );
                      },
                  },
              ]
            : []),
    ];

    const rowsWithIds = (Array.isArray(students) ? students : []).map((row, index) => ({
        ...row,
        _rowId: row.Student_Id ? `stu-${row.Student_Id}-${row.Admission_Id || index}` : `row-${index}`,
        index: page * pageSize + index + 1,
    }));

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const data = XLSX.utils.sheet_to_json(sheet);
            setExcelData(data);
        };

        reader.readAsArrayBuffer(file);
    };

    const handleImport = async () => {
        const batchSize = 5000;
        for (let i = 0; i < excelData.length; i += batchSize) {
            const batch = excelData.slice(i, i + batchSize);
            await axios.post(`${BASE_URL}/upload-student-excel`, { data: batch });
        }
    };

    // Search Section
    async function getstudents(searchtext) {
        axios
            .post(`${BASE_URL}/getAdmittedStudent`, { param: searchtext || "" })
            .then((res) => {
                setData(Array.isArray(res.data) ? res.data : []);
            })
            .catch(() => setData([]));
    }

    async function getBatchcode(searchtext) {
        axios
            .post(`${BASE_URL}/getSearchBatch`, { param: searchtext || "" })
            .then((res) => {
                setData(Array.isArray(res.data) ? res.data : []);
            })
            .catch(() => setData([]));
    }

    async function getEmail(searchtext) {
        axios
            .post(`${BASE_URL}/getSearchEmail`, { param: searchtext || "" })
            .then((res) => {
                setData(Array.isArray(res.data) ? res.data : []);
            })
            .catch(() => setData([]));
    }

    async function getCourse(searchtext) {
        axios
            .post(`${BASE_URL}/getSearchInquiryCourse`, { param: searchtext || "" })
            .then((res) => {
                setData(Array.isArray(res.data) ? res.data : []);
            })
            .catch(() => setData([]));
    }

    async function getMobile(searchtext) {
        axios
            .post(`${BASE_URL}/getSearchMobile`, { param: searchtext || "" })
            .then((res) => {
                setData(Array.isArray(res.data) ? res.data : []);
            })
            .catch(() => setData([]));
    }

    const onsearchformSumbit = (e) => {
        if (e && e.preventDefault) e.preventDefault();

        if (!searchwise || !searchdata) {
            return;
        }

        setLoading(true);
        const postData = {
            searchwise: searchwise,
            search: searchdata,
        };

        axios
            .post(`${BASE_URL}/getserchresult`, postData)
            .then((res) => {
                const studentList = res.data?.data || (Array.isArray(res.data) ? res.data : []);
                setStudents(studentList);
                const count =
                    res.data?.totalCount !== undefined
                        ? (studentList.length < pageSize ? studentList.length : res.data.totalCount)
                        : studentList.length;
                setTotalStudent(count);
                setPage(0);
            })
            .catch((err) => {
                console.error("Search error:", err);
                setStudents([]);
                setTotalStudent(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleClear = () => {
        setSearchWise("");
        setSearchData("");
        setSelectedStudent(null);
        setText("");
        setData([]);
        setPage(0);
        getOnlineAdmissions(0, pageSize);
    };

    const handlesearchselect = (value) => {
        setSearchWise(value);
        setSelectedStudent(null);
        setSearchData("");
        setData([]);

        if (value === "BatchWise") {
            getBatchcode("");
        } else if (value === "EmailWise") {
            getEmail("");
        } else if (value === "NameWise") {
            getstudents("");
        } else if (value === "CourseWise") {
            getCourse("");
        } else if (value === "MobileWise") {
            getMobile("");
        }
    };

    const handleSearchChange = (newValue) => {
        setSelectedStudent(newValue);

        if (searchwise === "NameWise") {
            setSearchData(newValue?.Student_Id);
        } else if (searchwise === "BatchWise") {
            setSearchData(newValue?.Batch_code);
        } else if (searchwise === "EmailWise") {
            setSearchData(newValue?.Email);
        } else if (searchwise === "MobileWise") {
            setSearchData(newValue?.Present_Mobile);
        } else if (searchwise === "CourseWise") {
            setSearchData(newValue?.Course_Id);
        }
    };

    const handleInputChange = _debounce((newValue) => {
        setText(newValue);

        if (searchwise === "BatchWise") {
            getBatchcode(newValue);
        } else if (searchwise === "NameWise") {
            getstudents(newValue);
        } else if (searchwise === "EmailWise") {
            getEmail(newValue);
        } else if (searchwise === "MobileWise") {
            getMobile(newValue);
        } else if (searchwise === "CourseWise") {
            getCourse(newValue);
        }
    }, 500);

    return (
        <div className="container-fluid page-body-wrapper ">
            <InnerHeader />
            {loading && <Loader />}
            <div className="main-panel" style={{ display: loading ? "none" : "block" }}>
                <div className="content-wrapper ">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row " style={{ width: "100%", padding: "10px 0" }}>
                                        <div className="col-lg-7 ">
                                            <form className="row align-items-center" onSubmit={onsearchformSumbit}>
                                                {/* <h4 class="card-title">Student Information</h4> */}

                                                <div className="form-group col-lg-3">
                                                    <FormControl fullWidth size="small">
                                                        <InputLabel id="demo-simple-select-label">
                                                            Select Search
                                                        </InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            value={searchwise}
                                                            label="Select Search"
                                                            onChange={(e) => handlesearchselect(e.target.value)}
                                                        >
                                                            <MenuItem value="Select">Select</MenuItem>
                                                            <MenuItem value="NameWise">Name Wise</MenuItem>
                                                            <MenuItem value="BatchWise">Batch Wise</MenuItem>
                                                            <MenuItem value="CourseWise">Course Wise</MenuItem>
                                                            <MenuItem value="EmailWise">Email Wise</MenuItem>
                                                            <MenuItem value="MobileWise">Mobile Wise</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </div>

                                                <div className="form-group col-lg-5">
                                                    <Autocomplete
                                                        size="small"
                                                        disablePortal
                                                        options={data}
                                                        getOptionLabel={(option) => {
                                                            if (!option) return "";
                                                            if (typeof option === "string") return option;
                                                            return searchwise === "NameWise"
                                                                ? option.Student_Name || ""
                                                                : searchwise === "BatchWise"
                                                                ? option.Batch_code || ""
                                                                : searchwise === "EmailWise"
                                                                ? option.Email || ""
                                                                : searchwise === "MobileWise"
                                                                ? option.Present_Mobile || ""
                                                                : searchwise === "CourseWise"
                                                                ? option.Course_Name || ""
                                                                : "";
                                                        }}
                                                        value={selectedStudent}
                                                        onChange={(e, newValue) => handleSearchChange(newValue)}
                                                        onInputChange={(e, newInputValue) =>
                                                            handleInputChange(newInputValue)
                                                        }
                                                        renderOption={(props, option) => (
                                                            <li
                                                                {...props}
                                                                key={
                                                                    option.Student_Id ||
                                                                    option.Batch_Id ||
                                                                    option.Course_Id ||
                                                                    option.Email ||
                                                                    Math.random()
                                                                }
                                                            >
                                                                {searchwise === "NameWise"
                                                                    ? option.Student_Name
                                                                    : searchwise === "BatchWise"
                                                                    ? option.Batch_code
                                                                    : searchwise === "EmailWise"
                                                                    ? option.Email
                                                                    : searchwise === "MobileWise"
                                                                    ? option.Present_Mobile
                                                                    : searchwise === "CourseWise"
                                                                    ? option.Course_Name
                                                                    : ""}{" "}
                                                            </li>
                                                        )}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label="Enter.." />
                                                        )}
                                                    />
                                                </div>

                                                <div className="form-group col-lg-2">
                                                    <Button
                                                        type="submit"
                                                        variant="contained"
                                                    >
                                                        Search
                                                    </Button>
                                                </div>
                                                <div className="form-group col-lg-2">
                                                    <Button
                                                        type="button"
                                                        onClick={handleClear}
                                                        variant="contained"
                                                    >
                                                        Clear
                                                    </Button>
                                                </div>
                                            </form>
                                        </div>

                                        <div className="col-lg-5">
                                            <p className="float-right">
                                                <b>Total Student :</b>
                                                {totalstudent}
                                            </p>
                                        </div>
                                    </div>

                                    <div>
                                        <div
                                            className="card"
                                            style={{
                                                borderLeft: "1px solid #dce4ec",
                                                height: "510px",
                                                overflow: "hidden",
                                            }}
                                        >
                                            <StyledDataGrid
                                                rows={rowsWithIds}
                                                columns={columns}
                                                rowHeight={37}
                                                disableColumnSelector
                                                disableDensitySelector
                                                getRowId={(row) => row._rowId}
                                                hideFooter
                                                autoHeight={false}
                                                sx={{
                                                    height: 500,
                                                    "& .MuiDataGrid-cell": {
                                                        borderRight: "1px solid #ccc",
                                                    },
                                                }}
                                            />
                                        </div>
                                        <div className="float-right py-2 mt-3">
                                            <button
                                                onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                                                disabled={page === 0}
                                            >
                                                Previous
                                            </button>

                                            <span>Page {page + 1}</span>

                                            <button
                                                style={{ marginRight: "50px" }}
                                                onClick={() => setPage((prev) => prev + 1)}
                                                disabled={!lastStudentId}
                                            >
                                                Next
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Students;
